export default __webpack_public_path__ + "static/media/popup-image.64fc3b43.svg";